// extracted by extract-css-chunks-webpack-plugin
module.exports = {"toggle":"toggle_2G2Rc","toggle_active":"toggle_active_RE+VQ","list":"list_rhsIv","list_active":"list_active_3mSd+"};